import { ApplicationConfig, provideZoneChangeDetection, isDevMode, importProvidersFrom, APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { themeReducer } from './store/reducer/theme.reducer';
import { NGX_ECHARTS_CONFIG, NgxEchartsModule } from 'ngx-echarts';
import { authReducer } from './auth/store/auth.reducer';
import { toastReducer } from './store/reducer/toaster.reducer';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ToastEffects } from './store/effects/toaster.effect';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { AuthService } from './auth/auth.service';
import { apiInterceptor } from './interceptor/api-interceptor.interceptor';
import { courseReducer } from './pages/courses/store/course.reducer';
import { GlobalErrorHandler } from './interceptor/error-handler.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (auth: AuthService) => () => auth.loadAuthDataFromLocalStorage(),
      deps: [AuthService],
      multi: true
    },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    importProvidersFrom(NgxEchartsModule),
    {
      provide: NGX_ECHARTS_CONFIG,
      useValue: { echarts: () => import('echarts') }
    },
    provideHttpClient(withInterceptors([apiInterceptor])),
    // { provide: ErrorHandler, useClass: GlobalErrorHandler }, //global lvl err handler
    provideClientHydration(),
    provideHttpClient(), 
    provideStore({
      theme: themeReducer,
      auth: authReducer,
      toasts: toastReducer,
      course:courseReducer,
    }),
    provideEffects(ToastEffects),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: false,
      autoPause: true,
      features: {
        pause: false,
        lock: true,
        persist: true,
      }
    }), provideAnimationsAsync(),

  ]
};
